'use client'
import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'

export const MediaCardMain = ({ children }: PropsWithChildren) => {
  return <div className={cn('w-full h-64 rounded-lg')}>{children}</div>
}
